module.exports = __webpack_public_path__ + "static/img/pika_stand.03084757.png";